import { setEvaluatedFlagEventProperties } from "@homeinstead/analytics";
import { useLayoutEffect } from "react";

/**
 * Seeds `flag_*` Segment middleware properties from server-evaluated flags (DEX-2412).
 * Clears flags when `evaluatedFlagProperties` is omitted (legacy routes, 404).
 */
function useEvaluatedFlagsSync(
  evaluatedFlagProperties: Record<string, string> | undefined,
): void {
  const evaluatedFlagPropertiesSnapshotKey = evaluatedFlagProperties
    ? JSON.stringify(evaluatedFlagProperties)
    : undefined;

  useLayoutEffect(() => {
    if (!evaluatedFlagPropertiesSnapshotKey) {
      setEvaluatedFlagEventProperties({});
      return;
    }

    setEvaluatedFlagEventProperties(evaluatedFlagProperties);

    return () => {
      setEvaluatedFlagEventProperties({});
    };
    // evaluatedFlagProperties omitted from deps; snapshotKey is JSON of that map.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- value-stable via snapshotKey
  }, [evaluatedFlagPropertiesSnapshotKey]);
}

export { useEvaluatedFlagsSync };
